module.exports = __webpack_public_path__ + "static/media/twitch.d01148db.jpg";